<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <b-button variant="outline-primary" size="sm" v-if="$localStorageService.can('DX_14_asigna_coordiEspec')"
        @click="putAsignarCoordinadorEspecialidad(data.item)" 
        :disabled="!data.item.idespecialidad || !data.item.idEmpleadoCoordinador">Asignar</b-button>
    </div>  
</template>

<script>
    export default {
        name: "BandejaBotonAsignarComponente",
        props: {
            data: Object,
            resource: Object
        },
        data: () => ({
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,
        }),
        created(){
          this.debug = this.$localStorageService.getDebug();
        },
        methods: { 
            putAsignarCoordinadorEspecialidad(datos) {

            // idEmpleado
            var params = {
                idEmpleadoCoordinador: datos.idEmpleadoCoordinador,
                idEmpleadoResponsable: this.$localStorageService.getIdEmpleado(),
                idEspecialidad: datos.idespecialidad,
            };

            this.$http
                .put(
                    this.$api +
                    "ptialtoriesgo/asignarcoordinadorespecialidad/" + datos.pti, params
                )
                .then((response) => {
                    this.arrayDatosPtisServicio = response.data.data;
                    this.$swal.fire({
                        icon: 'success',
                        title: this.arrayDatosPtisServicio.mensajeRespuestaServicio
                    });
                })
                .catch((error) => {
                    this.$swal.fire({
                        icon: "error",
                        title: "Ocurrio un error",
                        text: error.message,
                    });
                }).finally(() =>   
                    this.$emit("_funcionExtra", 1)
                );
                 
        },

        }
    }
</script>
